import { isSecureApplePayContext, loadApplePaySdk, logger } from '@trx/shared';
import { useEffect, useState } from 'react';
import { ValidFieldTypes } from '../../types';
import type { FieldViewProps } from '../../page/types';
import type { IConfig } from '../../types';
import type { ECardType } from '../../utils';

type UseInitOtherFieldProps = {
  fieldType: string;
};

export const useInitOtherField = ({ fieldType }: UseInitOtherFieldProps): FieldViewProps & { isInit: boolean } => {
  const [isInit, setIsInit] = useState(false);
  const [data, setData] = useState<Partial<IConfig>>({});
  const [potentialCardType, setPotentialCardType] = useState<ECardType | null>(data.preffiledCardType ?? null);

  useEffect(() => {
    if (fieldType === ValidFieldTypes.APPLE_PAY) {
      // For Apple Pay field we need to load Apple Pay JS before initialization
      if (isSecureApplePayContext(window)) {
        void loadApplePaySdk(document).then(() => {
          setIsInit(true);
        });
      } else {
        logger.error('Apple Pay is not supported on this browser.');
        setIsInit(true);
      }
    } else {
      setIsInit(true);
    }
  }, [fieldType]);

  return { isInit, data, error: undefined, setData, potentialCardType, setPotentialCardType };
};
